import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { useServiceRequestQuery } from "../../../../hooks/ReactQueryHooks/useServiceRequestQuery";
import { finishAppointmentReferral } from "../../../apps/ServiceRequest/appointmentReferral";

export default function AppointmentReferralRecovery({ appointment }) {
  const patientId = appointment.patients?.find(p => p.role === "subject")?.patientRef;
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [saveError, setSaveError] = useState("");
  const query = useServiceRequestQuery({ patientId, enabled: !!patientId, retry: false });
  if (query.isLoading) return <p role="status">Checking referral…</p>;
  if (query.error || !Array.isArray(query.data)) return <p role="alert">Could not check the referral. <button onClick={() => query.refetch()}>Retry</button></p>;
  if (query.data?.some(row => row.id === `v2-${appointment.appointmentId}`)) return null;
  const finish = async () => {
    setBusy(true); setSaveError("");
    try {
      await finishAppointmentReferral(appointment);
      await queryClient.invalidateQueries(["service-request", patientId]);
    } catch (error) { setSaveError(error?.response?.data?.message || error.message); }
    finally { setBusy(false); }
  };
  return <div role="status">
    <p>The appointment exists, but its referral has not been saved.</p>
    {saveError && <p role="alert">{saveError}</p>}
    <button type="button" disabled={busy} onClick={finish}>{busy ? "Saving referral…" : "Finish referral"}</button>
  </div>;
}
